<template>
  <span class="d-inline" v-if="isDisplay" v-cloak>
    <div class="d-flex align-center">
      <a href="#none" @click.prevent="movePayment('service')" class="eAppVersion mr-3" v-cloak>
        <div v-if="$store.state.mode === AUTH_SERVICE.APP_MODE.ANY" v-cloak>
          <span>사용 기간 만료되었습니다.</span>
        </div>
        <div v-else>
          <span v-if="$store.state.mode === AUTH_SERVICE.APP_MODE.BASIC" v-cloak>베이직 버전 사용중</span>
          <span v-else>서비스 사용중</span>
          <span v-cloak>{{ setExpiresDays(this.$store.state.expires_at) }}</span>
        </div>
      </a>
      <div v-if="this.appCode !== 'cert_digital' && this.mallType === 'mall'" class="d-flex align-center">
        |
        <a href="#none" @click.prevent="movePayment('point')" class="eAppVersion ml-3 mr-5" v-cloak>
          비즈포인트 ( {{ this.$store.state.point | numberFormat }} P )
        </a>
      </div>
      <v-btn depressed small color="white" class="black--text font-weight-black" aling="left" @click="useGuldeImageShow()"
        >사용 가이드</v-btn
      >

      <template style="margin-top:10px;">
        <div class="text-center ml-4" v-show="this.mallType !== 'imweb'">
          <v-menu offset-y max-width="480">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon color="white">mdi-apps</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/10777')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img src="/authservice/etc/service_images/survey_icon.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold body-1 black--text mb-0 d-block">
                    <p class="mb-1 float-left align-center justify-center" style="line-height: 1.8;">
                      맞춤 질문 추천 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    고객 취향에 맞춘 개인화 상품 추천서비스.<br />
                    고객이 선택한 답변에 따라 상품을 추천하므로<br />
                    구매율과 만족도를 높여줍니다.<br />
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/6711')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img src="/authservice/etc/service_images/membership.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold body-1 black--text mb-0 d-block">
                    <p class="mb-1 float-left align-center justify-center" style="line-height: 1.8;">
                      유료 멤버십 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    >쇼핑몰 회원들에게 제공되는 차별화된 서비스.<br />
                    쇼핑몰 구독시대에 필요한 특별한 서비스로<br />
                    고객 이탈을 막고 충성고객을 확보하세요.</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="this.appCode === 'cert_digital'"
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/4238')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img src="/authservice/etc/service_images/auth-code-service-icon.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold body-1 black--text mb-0 d-block">
                    <p class="mb-1 float-left align-center justify-center" style="line-height: 1.8;">
                      정품 인증 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    >회원가입 및 브랜드 가치를 높여주는 서비스.<br />
                    정품 인증 회원에게 다양한 프로모션을 제공하고<br />
                    충성 고객으로 만들어보세요!</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="this.appCode === 'cert_product'"
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/31135')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img src="/authservice/etc/service_images/digital_icon.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold body-1 black--text mb-0 d-block">
                    <p class="mb-1 float-left align-center justify-center" style="line-height: 1.8;">
                      디지털 상품 인증 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    배송 상태가 필요없는 디지털 상품 발송 서비스.<br />
                    실시간 결제 확인 및 배송 상태를 자동 변경하며<br />
                    등록한 시리얼 코드를 발송해줍니다.</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </div>
  </span>
</template>
<style scoped>
[v-clock] {
  display: none;
}

.eAppVersion {
  color: white;
  text-decoration: none;
}

.eAppVersion:hover {
  text-decoration: underline;
}
</style>
<script>
import { AUTH_SERVICE } from "@/datas/authservice";
import Filters from "@/libs/authservice/filters.js";

export default {
  data: () => ({
    AUTH_SERVICE,
    versionText: "D - day",
    isDisplay: false,
  }),
  computed: {
    appCode: function() {
      return this.$store.state.appCode;
    },
    mallType: function() {
      return this.$store.state.mallType;
    },
  },
  methods: {
    setExpiresDays: function(expiresDate) {
      if (expiresDate !== null) {
        let toDay = new Date();
        let expDate = expiresDate.substr(0, 10);
        let expParts = expDate.split("-");
        var endDate = new Date(expParts[0], expParts[1] - 1, expParts[2]);
        var gap = toDay.getTime() - endDate.getTime();
        var result = Math.floor(gap / (1000 * 60 * 60 * 24)) * -1;
        return ` ( D-day ${result} )`;
      }
    },
    movePayment: function(type) {
      this.$router.push(
        {
          path: `/authservice/${this.$store.state.mallId}/payment`,
          query: { type: type },
        },
        { replace: true },
      );
    },
    cafe24SiteShow: function(url) {
      window.open(url, "_blank");
    },
    chromeDownLoad: function() {
      window.open("https://www.google.com/intl/ko/chrome/", "_blank");
    },
    useGuldeImageShow: function() {
      window.open(`https://shoplus.gitbook.io/cert-product`, "_blank");
    },
  },
  filters: Filters,
  mounted: function() {
    this.$nextTick(function() {
      setTimeout(() => {
        this.isDisplay = true;
      }, 500);
    });
  },
};
</script>
